// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"66":"textbanner","670":"credits","956":"Debugger"}[chunkId] || chunkId) + "." + {"66":"09f7a597","520":"dd704f41","670":"956497c5","956":"9812694b","962":"a15ce141"}[chunkId] + ".js";
};